/**
 * Created by Jan Bradac on 5.8.2016.
 */


(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.Events;

    (function (Events, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.Events, 'NamesGenerator')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Provides consistent namespaced identifiers for actions and events.
         *
         * @memberOf Lfl.Events
         */
        Lfl.Events.NamesGenerator;

        (function (NamesGenerator, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition 
            |===========================================================================================================
            */

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            // Note: there is no method to create an eventName from lfl prefix, component name and event's "short" name.
            //       That is because we treat the event name as a constant and therefore do not want to split it.
            //          See: Js::JqueryNamespacing::DefiningEventNames

            /**
             * Provides an event with namespace using an action name. Used for applications where the given event
             * listener (the given action) is expected to be turned off again at some time.
             *
             * Warning: This method's "actionName" is actually a second namespace - see: Js::JqueryNamespacing::DotSeparated
             *      TODO Later - Fix this.
             *          So: Should probably replace 'namespace + "." + actionName' with "-" or rename actionName to
             *          secondNamespace.
             *              Therefore should be renamed to something like generateActionNamespacedName
             * @memberOf Lfl.Events.NamesGenerator
             * @param {string} eventName
             * @param {string} [namespace]
             * @param {string} [actionName]
             * @returns {string}
             */
            NamesGenerator.generateEventName = function (eventName, namespace, actionName) {
                if (typeof actionName === 'undefined') {
                    actionName = NamesGenerator.generateActionName();
                }

                if (typeof namespace === 'undefined') {
                    // Note: this is outdated and is in fact not a very good name space - see: Js::JqueryNamespacing
                    //      Todo Later: Should probably be lfl-events
                    namespace = 'lfl.events'
                }

                return eventName + "." + namespace + "." + actionName;
            };

            // TODO use in CVdrag distinguisher
            /**
             * Generates an unique name for an action (action == callback provided to be performed when some event occurs).
             * @memberOf Lfl.Events.NamesGenerator
             * @param prefix
             * @returns {string}
             */
            NamesGenerator.generateActionName = function (prefix) {
                if (typeof prefix === 'undefined') {
                    prefix = 'generic';
                }
                var d = new Date();
                var mills = d.getMilliseconds();
                // Todo Later - should use '-' instead of '.' - see: Js::JqueryNamespacing::DotSeparatedValues
                return prefix + "." + mills + "." + Math.random();
            };

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */
        }(Events.NamesGenerator = Events.NamesGenerator || {}, jQuery));
    }(Lfl.Events = Lfl.Events || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
